module.exports = __webpack_public_path__ + "static/media/button-icon.b0166da6.svg";